import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";

const styles = {
  container: {
    position: "relative",
  },
  searchWrap: {
    position: "absolute",
    left: "2%",
    top: "50%",
    transform: "translateY(-50%)",
    width: "38px",
    height: "37px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    backgroundColor: "#536DFE",
  },
  icon: {
    color: "#fff",
    fontSize: "15px",
  },
  input: {
    border: "1px solid #536DFE",
    outline: "none",
    background: "#fff",
    borderRadius: "30px",
    padding: "12px 16px 12px 50px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
  },
};

const SearchBar = ({ onSearch, placeholder }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleChange = (e) => {
    const value = e.target.value.replace(/^\s+/, "");
    setSearchTerm(value);
    onSearch(value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSearch(searchTerm.trimStart());
    }
  };

  return (
    <div style={styles.container}>
      <span style={styles.searchWrap}>
        <FaSearch style={styles.icon} />
      </span>
      <input
        type="text"
        placeholder={placeholder}
        value={searchTerm}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        style={styles.input}
      />
    </div>
  );
};

export default SearchBar;
